import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { ClinicianRole, LoginType, MedicalAssistantRole } from "src/app/common/settings/settings";

  export function roleValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const rootFormGroup = getRootFormGroup(control);
      const loginType = rootFormGroup?.get('loginType')?.value;
      const value = control.value;
      const concurrentRoles = [ClinicianRole, MedicalAssistantRole];
      if (concurrentRoles.includes(value) && loginType === LoginType.Password) {
        return { invalidRole: 'Invalid role!' };
      }
      return null; 
    };
  }

  export function getRootFormGroup(control: AbstractControl): FormGroup | null {
    let parent = control.parent;
    
    while (parent && parent.parent) {  // Traverse up the tree to find the root FormGroup
      parent = parent.parent;
    }
    
    return parent as FormGroup;
  }

  export function loginTypeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      
      if (value === LoginType.Password) {
        return { invalidType: 'Invalid login type!' };
      }
      return null; 
    };
}

